import React, { useState } from 'react';
import { Button, Space, Modal, Input, Form, Row, Col, Tag, Tooltip, Typography, notification } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CustomSelect from '../../components/CustomSelect';
import ThemDoiTac from './components/themDoiTac';
import ThongTinDoiTac from './components/thongTinDoiTac';
import NormalFormLabel from '../../components/NormalFormLabel';
import SuaDoiTac from './components/suaDoiTac';
import { useQuery, useMutation } from '@tanstack/react-query';
import { getListPartnerRequest } from '../../services/partnerRequest';
import { deletePartnerRequest } from '../../services/partnerRequest';
import { checkPermission } from '../../utils/checkPermission';
import { LIST_STATUS_PARTNER } from '../../constants/appSelect';
import { newObjectKeys } from '../../utils/utility';
import { ADD_PARTNER, DELETE_PARTNER, GET_LIST_PARTNERS, UPDATE_PARTNER } from '../../constants/apiEndPoint';
import { TableCustomV3 } from '../../components/TableCustomV3';
import { isEqual } from 'lodash';

const QuanLyDoiTac = () => {
  const [formSearch] = Form.useForm();
  const [confirmOpen, setConfirmOpen] = useState(false); // Controls "Thêm đối tác" modal
  const [detailOpen, setDetailOpen] = useState(false); //
  const [infoOpen, setInfoOpen] = useState(false); // Controls "Thông tin đối tác" modal
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [params, setParams] = useState({
    pageId: 1,
    limit: 20,
    status: [0, 1, 3],
  });

  const {
    data: dataPartners,
    isPending,
    refetch: refetchDataPartners,
  } = useQuery({
    queryKey: ['dataPartners', params],
    queryFn: () => getListPartnerRequest(params),
    enabled: checkPermission(GET_LIST_PARTNERS, 'Xem danh sách'),
  });

  const { mutate: deletePartner } = useMutation({
    mutationFn: deletePartnerRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Xóa đối tác thành công!',
        });
        refetchDataPartners();
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleDelete = (result) => {
    deletePartner(result);
  };

  const checking = (record) => {
    setSelectedPartnerId(record);
    setDetailOpen(true);
  };

  const handleEdit = (record) => {
    setSelectedPartnerId(record);
    setInfoOpen(true);
  };

  const handleConfirm = (record, actionType) => {
    let modalConfig = {};
    if (actionType === 'delete') {
      modalConfig = {
        title: 'Xác nhận hành động',
        content: 'Bạn có muốn xóa đối tác này không?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        okType: 'danger',
        onOk() {
          handleDelete(record.id);
        },
        onCancel() {},
      };
    } else {
      return;
    }
    Modal.confirm(modalConfig);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '60px',
      fixed: 'left',
    },
    {
      title: 'Tên đối tác',
      dataIndex: 'name',
      render: (name, record) => <a onClick={() => checking(record)}>{name}</a>,

      key: 'name',
      width: '200px',
      fixed: 'left',
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      width: '200px',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
      key: 'phone',
      width: '130px',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '200px',
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: 'modify_time',
      key: 'modify_time',
      width: '170px',
      render: (_, { modify_byName, modify_time }) => (
        <Space direction="vertical">
          <Typography.Text>{modify_byName}</Typography.Text>
          <Typography.Text>{modify_time}</Typography.Text>
        </Space>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag
          style={{
            backgroundColor: LIST_STATUS_PARTNER.find((item) => item.value === status)?.color,
            color: 'white',
            borderRadius: '8px',
            padding: '4px 10px',
          }}
        >
          {LIST_STATUS_PARTNER.find((item) => item.value === status)?.label}
        </Tag>
      ),
      width: '130px',
      fixed: 'right',
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {checkPermission(UPDATE_PARTNER, 'Chỉnh sửa') && (
            <Tooltip title="Sửa đối tác">
              <a onClick={() => handleEdit(record)}>
                <EditOutlined />
              </a>
            </Tooltip>
          )}
          {checkPermission(DELETE_PARTNER, 'Xóa') && record?.status !== 2 && (
            <Tooltip title="Xóa đối tác">
              <a onClick={() => handleConfirm(record, 'delete')}>
                <DeleteOutlined />
              </a>
            </Tooltip>
          )}
        </Space>
      ),
      width: '90px',
      fixed: 'right',
    },
  ];

  const handleSubmitForm = (values) => {
    const temp = { pageId: 1, limit: 20 };

    if (values?.name) {
      Object.assign(temp, { name: values?.name });
    }

    if (values?.email) {
      Object.assign(temp, { email: values?.email });
    }

    if (values?.phone) {
      Object.assign(temp, { phone: values?.phone });
    }

    if (values?.status >= 0) {
      Object.assign(temp, { status: [values?.status] });
    } else {
      Object.assign(temp, { status: [0, 1, 3] });
    }
    if (isEqual(temp, params)) {
      refetchDataPartners();
    } else {
      setParams(temp);
    }
  };

  return (
    <div className="flex flex-col justify-start gap-4">
      <div className="flex justify-between items-center">
        <h1 className="font-semibold text-2xl font-roboto">Danh sách đối tác</h1>
        {checkPermission(ADD_PARTNER, 'Tạo mới') && (
          <Button className="w-[136px] h-[40px]" type="primary" onClick={() => setConfirmOpen(true)}>
            <PlusOutlined />
            Thêm đối tác
          </Button>
        )}
      </div>

      <ThemDoiTac Confirm={setConfirmOpen} visible={confirmOpen} refetchDataPartners={refetchDataPartners} />

      <ThongTinDoiTac
        Confirm={setDetailOpen}
        visible={detailOpen}
        selectedPartnerId={selectedPartnerId}
        refetchDataPartners={refetchDataPartners}
      />

      <SuaDoiTac
        Confirm={setInfoOpen}
        visible={infoOpen}
        selectedPartnerId={selectedPartnerId}
        refetchDataPartners={refetchDataPartners}
      />
      {checkPermission(GET_LIST_PARTNERS, 'Xem danh sách') && (
        <>
          <Form
            layout="vertical"
            name="search-partner"
            form={formSearch}
            requiredMark={false}
            onFinish={handleSubmitForm}
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12} lg={6}>
                <Form.Item label={<NormalFormLabel text="Tên đối tác" />} name="name">
                  <Input allowClear placeholder="Nhập tên đối tác..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Form.Item label={<NormalFormLabel text="Số điện thoại" />} name="phone">
                  <Input allowClear placeholder="Nhập số điện thoại..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Form.Item label={<NormalFormLabel text="Email" />} name="email">
                  <Input allowClear placeholder="Nhập email..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Form.Item label={<NormalFormLabel text="Trạng thái" />} name="status" initialValue={-1}>
                  <CustomSelect
                    placeholder="Trạng thái"
                    options={[{ value: -1, label: 'Tất cả' }, ...LIST_STATUS_PARTNER]}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} lg={6} className="flex items-center gap-2">
                <Button type="primary" className=" " htmlType="submit">
                  <SearchOutlined /> Tìm kiếm
                </Button>
                {params &&
                  Object.values(newObjectKeys(params, ['name', 'email', 'phone', 'status'])).some(
                    (value) => (value && !Array.isArray(value)) || value?.length === 1
                  ) && (
                    <Button
                      htmlType="button"
                      onClick={() => {
                        formSearch.resetFields();
                        setParams({ pageId: 1, limit: params.limit, status: [0, 1, 3] });
                      }}
                    >
                      <DeleteOutlined />
                      Xóa lọc
                    </Button>
                  )}
              </Col>
            </Row>
          </Form>

          <TableCustomV3
            isLoading={isPending}
            columns={columns}
            dataSource={dataPartners?.data}
            totalItem={dataPartners?.totalItem}
            params={params}
            setParams={setParams}
          />
        </>
      )}
    </div>
  );
};

export default QuanLyDoiTac;
